import React from 'react'
import { useLocation } from 'react-router-dom'

import Slide from './Slide'
import Wrapper from './Wrapper'
import Block from './Block'
import Title from './Title'
//import PdfFlipbook from './PdfFlipbook'

const Promos = () => {
  const location = useLocation()
  const type = location.pathname.split('/promos-')[1]
  const date = new Date()
  const mois = date.toLocaleDateString('fr-FR', { month: 'long' })
  const annee = date.getFullYear()
  const mois_courrant = `${mois}_${annee}`
  .replace(/ /g, '_')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')

  var pdf_interactif = 'horeca'
  if(type === "drinks") {
    pdf_interactif = 'particulier'
  }
  
  return (
    <>
      <section className="relative">
        <Title blockKey={`slider_${type}`} />
        <Slide blockKey={`slider_${type}`} />
      </section>

      <section className="bg_light color_secondary">
        <Wrapper>
          {type === 'horeca' ? (
            <Block blockKey="block6" />
          ) : (
            <Block blockKey="promo_drink" />
          )}
          <div className="my-4 text-center">
            <a
              className="inline-block button"
              href={`/data/pdf/promo-${type}-${mois_courrant}.pdf`}
            >
              Téléchargez Nos promos {type}
            </a>
          </div>
        </Wrapper>
        <div className="hidden md:block min-h-screen w-12/12">
          <embed
            className="min-h-screen w-12/12 border-0"
            src={`https://distriboissons.be/actualites/${pdf_interactif}/index.html`}
            //src={`/data/pdf/promo-${type}-${mois_courrant}.pdf`}
            type="application/pdf"
          />
          {/* 
          <PdfFlipbook
            pdfUrl={`/data/pdf/promo-${type}-${mois_courrant}.pdf`}
          />
           */}
        </div>
      </section>

      <iframe
        className="hidden min-h-screen w-12/12 border-0"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Distriboissons - Promo"
        src="https://distriboissons.be/actualites/horeca/index.html"
      ></iframe>

      <section className="bg_primary color_light">
        <Wrapper>
          <Block blockKey="block7" />
        </Wrapper>
      </section>
    </>
  )
  }
  
  export default Promos
  